export default __webpack_public_path__ + "static/media/bird.4085db41.jpg";